export default __webpack_public_path__ + "static/media/Sash of the Revelations.1ead5444.jpg";